<div style="background-color: rgba(255, 255, 255, 1);">
    <div>
        <div class="super-main-head bg-head">Acount Setting</div>
        <div class="super-upper-cointainer">
            <div class="name-feild">
                <div class="text">
                    Name
                </div>
                <div>
                    <input type="text" class="form-control" [(ngModel)]="superAdminName">
                </div>
            </div>
            <div class="logo-feild">
                <div class="text">Profile</div>
                <div class="logo-container">
                    <span><img [src]="src" alt="" class="imgPreview" /></span>
                    <span style="margin-left: 8%">
                        <input type="file" accept="image/png,image/jpeg" (change)="onImageChange($event)"
                            #fileInput_image hidden />
                        <button class="uploadBtn" (click)="fileInput_image.click()">
                            <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                        </button>
                    </span>

                </div>
            </div>

        </div>
        <div style="display: flex;justify-content:flex-end;">
            <div class="common submitBtn" style="display: inline-flex;" (click)="updateInfo()">
                Update Profile
            </div>
        </div>
    </div>
    <div>
        <div class="super-bottom-cointainer">
            <div class="super-main-head bg-subhead">Change password</div>
            <div *ngIf="validCheckFlag" class="text-danger" style="text-align: center;">Password does not match</div>
            <div *ngIf="requiredMiss" class="text-danger" style="text-align: center;">All feilds are mandatory</div>
            <div class="ml-23 current-pass-div">
                <div class="text">Current Password</div>
                <div style="display: inline-flex;">
                    <input type="password" name="" id="" class="form-control" [(ngModel)]="oldPassword" (click)="inputClick()">
                </div>
            </div>
            <div class="ml-23 new-pass-div">
                <div>
                    <div class="text">New Password</div>
                    <div><input type="password" name="" id="" class="form-control" [(ngModel)]="newPassword" (click)="inputClick()"></div>
                </div>
                <div style="margin-left: 15%;">
                    <div class="text">Confirm Password</div>
                    <div><input type="password" name="" id="" class="form-control" [(ngModel)]="confirmPassword" (click)="inputClick()"></div>
                </div>
            </div>
        </div>
        <div style="display: flex;justify-content:flex-end;">
            <!-- <div class="common closeBtn">
                Close
            </div> -->
            <div class="common submitBtn" (click)="updatePasswordAdmin()">
                Update Password
            </div>
        </div>
    </div>
</div>